module.exports = __webpack_public_path__ + "static/media/sectors.6f6d2466.svg";